<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      <span class="child">/ Invalid Questions</span>
    </v-row>
    <br />
    <v-card class="mx-auto">
      <v-col cols="12" sm="12" md="12">
        <center class="heading">Invalid Questions</center>
        <v-row class="vrow">
          <v-col sm="4">
            <v-autocomplete
              persistent-hint
              label="Academic Year"
              :items="ayList"
              item-text="ay"
              item-value="id"
              v-model="senddata.ayid"
            ></v-autocomplete>
          </v-col>
          <v-col sm="4">
            <v-autocomplete
              persistent-hint
              label="Semester"
              :items="semList"
              item-text="sem"
              item-value="id"
              v-model="senddata.semid"
            ></v-autocomplete>
          </v-col>
          <v-col sm="4">
            <v-autocomplete
              label="Exam"
              :items="examList"
              item-text="examname"
              item-value="id"
              v-model="senddata.examid"
              persistent-hint
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-btn class="button" @click="fatchData">
            Fetch Data
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-row>
        <br />
      </v-col>
    </v-card>
    <br />
    <template>
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="totalStudentCount"
          :search="search"
        >
          <template v-slot:[`item.question`]="{ item }">
            <span v-html="item.question">
              {{ item.question }}
            </span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn class="button" @click="process(item)">
              Process
              <template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>cached</v-icon>
                </span>
              </template>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </template>
    <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
      <v-card color="#4CAF50" dark>
        <v-card-text>
          "Please wait... Data is Loadding !!"
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import { VueMathjax } from "vue-mathjax";
export default {
  data: () => ({
    search: "",
    dialog_send: false,
    headers: [
      { text: "Sr. No.", value: "srno" },
      // { text: "lear Id", value: "lear" },
      { text: "Question Id", value: "questionid" },
      { text: "Question", value: "question" },
      { text: "Exam", value: "exam" },
      { text: "Total Students", value: "totalStundets" },
      { text: "Action", value: "action" },
    ],
    ayList: "",
    semList: "",
    examList: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    senddata: {
      ayid: null,
      semid: null,
      examid: null,
    },
    totalStudentCount: [],
  }),
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      axios
        .post("ExamResult/invalidQuestionHome")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.ayList = res.data.Ay_List;
              this.semList = res.data.Sem_List;
              this.examList = res.data.Exam_List;
            }
          } else {
            this.showSnackbar("#b71c1c", "Data not found...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },

    fatchData() {
        if(this.senddata.ayid==null)
        {
            this.showSnackbar("#b71c1c", "Select Academic Year...");
        }else if(this.senddata.semid==null){
            this.showSnackbar("#b71c1c", "Select Semester...");
        }else if(this.senddata.examid==null)
        {
            this.showSnackbar("#b71c1c", "Select Exam...");
        }else{
      this.dialog_send = true;
      axios
        .post("ExamResult/getinvalidQuestionHome", this.senddata)
        .then((res) => {
          if (res.data.msg == "200") {
            this.totalStudentCount = res.data.totalStudentCount;
            this.dialog_send = false;
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
        }
    },
    process(item) {
      axios
        .post("ExamResult/processinvalidQuestion", item)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("#4CAF50", "Successfully Processed...");
            this.dialog_edit = false;
            this.onLoad();
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
<style scoped>
.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}
.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}
.button1 {
  border: 2px solid hsla(190, 99%, 30%, 1) !important;
  color: rgb(1, 127, 152);
  background: white !important;
  border-radius: 50px;
}

.button1:hover {
  color: white;
  background: hsla(190, 99%, 30%, 1) !important;
}
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.toolbar-title {
  color: #ffffff !important;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.vrow {
  margin: 0.5rem !important;
  padding: 0.8rem !important;
}
.span-mr {
  margin: 0.7rem !important;
  padding: 0px;
}
.span-mr1 {
  margin: 0.2rem !important;
  padding: 0px;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
</style>
